import { ATTENDEES_KEY } from './attendeeSessionStorage';
import { useSessionStorage } from 'usehooks-ts';

export const PARTICIPANTS_KEY = 'participants';

export interface ParticipantData {
  attendance?: string;
  trackedTime?: number;
}

export interface ParamsParticipantData {
  [key: string]: ParticipantData;
}

export interface ParticipantsSearchParams {
  participants: ParamsParticipantData;
  updateParticipants: (participants: ParamsParticipantData) => void;
  resetParticipants: () => void;
}

// There is certainly a better way to get this to work - attempts to get tables to update when using a stateful variable based on the
// session storage were not successful - so leaving a call for updating search params even though we don't actually modify them
export function useParticipantSessionStorage(): ParticipantsSearchParams {
  const [participants, setParticipants] = useSessionStorage<ParamsParticipantData>(
    PARTICIPANTS_KEY,
    JSON.parse(sessionStorage.getItem(PARTICIPANTS_KEY) || '{}')
  );
  const [aliases, setAliases] = useSessionStorage<string[]>(
    ATTENDEES_KEY,
    sessionStorage.getItem(ATTENDEES_KEY)?.split(',') || []
  );

  const updateParticipants = (updatedParticipants: ParamsParticipantData) => {
    const newParticipantsData = { ...participants, ...updatedParticipants };

    // Also handle removing temporary participants from the alias list
    // This has to be done in the same SetSearchParams call to prevent a race condition
    const aliasesToRemove: string[] = [];

    for (const alias in updatedParticipants) {
      if (updatedParticipants[alias].attendance === 'DID_NOT_ATTEND' && aliases.includes(alias)) {
        aliasesToRemove.push(alias);
        // Clear the participants entry as well to make sure we don't generate unnecessary attendance records
        delete newParticipantsData[alias];
      }
    }

    const newAliases = aliases.filter((alias) => !aliasesToRemove.includes(alias));
    if (newAliases.length === 0) {
      setAliases([]);
    } else {
      setAliases(newAliases);
    }

    if (Object.keys(newParticipantsData).length === 0) {
      setParticipants({});
    } else {
      setParticipants(newParticipantsData);
    }
  };

  const resetParticipants = () => {
    setParticipants({});
  };

  return {
    participants,
    updateParticipants,
    resetParticipants,
  };
}
